
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { paymentMethods } from '@/data/paymentMethods';
import { CreditCard, Banknote, QrCode, Receipt, ArrowLeftRight, Wallet } from 'lucide-react';

interface TransactionPaymentMethodFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

const getPaymentIcon = (method: string) => {
  switch (method) {
    case 'pix': return QrCode;
    case 'dinheiro': return Banknote;
    case 'cartao': return CreditCard;
    case 'cartao_debito': return Wallet;
    case 'boleto': return Receipt;
    case 'transferencia': return ArrowLeftRight;
    default: return CreditCard;
  }
};

export const TransactionPaymentMethodField = ({ value, onChange, error, disabled }: TransactionPaymentMethodFieldProps) => {
  const selectedMethod = paymentMethods.find(m => m.value === value);
  const SelectedIcon = selectedMethod ? getPaymentIcon(selectedMethod.value) : CreditCard;

  return (
    <div>
      <Label htmlFor="paymentMethod">Meio de Pagamento</Label>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className={`rounded-xl ${error ? 'border-destructive' : ''}`}>
          <SelectValue placeholder="Selecionar meio">
            {selectedMethod && (
              <div className="flex items-center gap-2">
                <SelectedIcon className="h-4 w-4" />
                <span>{selectedMethod.label}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {paymentMethods.map(method => {
            const Icon = getPaymentIcon(method.value);
            return (
              <SelectItem key={method.value} value={method.value}>
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4" />
                  <span>{method.label}</span>
                </div>
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      {error && (
        <p className="text-sm text-destructive mt-1">{error}</p>
      )}
    </div>
  );
};
